import React, { useRef, useEffect, useState } from 'react';
import './App.css';
import Footer from './Footer';

const images = [
  './images/coverpage6.webp',
  './images/E1.webp',
  './images/E2.webp',
  './images/E3.webp',
];

const TravelForm = () => {
  const carouselRef = useRef(null);
  const [lang, setLang] = useState('en');

  useEffect(() => {
    const scrollInterval = setInterval(() => {
      if (carouselRef.current) {
        const container = carouselRef.current;
        const maxScrollLeft = container.scrollWidth - container.clientWidth;

        if (container.scrollLeft >= maxScrollLeft) {
          container.scrollLeft = 0;
        } else {
          container.scrollLeft += 260;
        }
      }
    }, 2000);

    return () => clearInterval(scrollInterval);
  }, []);

  const content = {
    en: `Ella is a beautiful small town in Sri Lanka’s hill country, famous for its stunning views, lush greenery, and relaxed vibe.

Key highlights include:

• Ella Rock – A popular hiking destination offering panoramic views of the surrounding valleys.
• Nine Arch Bridge – An iconic colonial-era railway bridge surrounded by tea plantations and waterfalls.
• Little Adam’s Peak – A relatively easy climb with spectacular sunrise views.
• Ravana Falls – A majestic waterfall named after the legendary King Ravana.
• Diyaluma Falls – Sri Lanka's second highest waterfall, located a short drive away.
• Demodara Loop – A fascinating railway loop famous among train enthusiasts.
• Ella Spice Garden – Offers cooking classes to learn traditional Sri Lankan cuisine.
• Rawana Cave – A historic cave linked to ancient legends.
• Local Markets – Selling fresh fruits, vegetables, and handcrafts.
• Authentic Local Foods – Try traditional Sri Lankan dishes and fresh tropical fruits.

Ella is also well known for its lively night life with cozy cafes, bars, and live music venues where travelers can unwind after a day of adventure.

Ella’s blend of natural beauty, culture, and relaxed atmosphere makes it a must-visit destination for nature lovers and explorers.`,

    zh: `艾拉是斯里兰卡山地的小镇，以其壮丽的景色、茂密的绿色植被和悠闲的氛围闻名。

主要亮点包括：

• 艾拉岩 – 受欢迎的徒步目的地，可俯瞰周围山谷的全景。
• 九孔桥 – 标志性的殖民时代铁路桥，周围环绕茶园和瀑布。
• 小亚当峰 – 相对轻松的攀登，适合观看壮观的日出。
• 拉瓦纳瀑布 – 以传说中王拉瓦纳命名的壮丽瀑布。
• 迪亚卢马瀑布 – 斯里兰卡第二高瀑布，距离不远。
• 德莫达拉环线 – 火车爱好者喜爱的铁路环线。
• 艾拉香料园 – 提供斯里兰卡传统烹饪课程。
• 拉瓦纳洞穴 – 与古老传说相关的历史洞穴。
• 当地市场 – 售卖新鲜水果、蔬菜和手工艺品。
• 地道美食 – 尝试传统斯里兰卡菜肴和新鲜热带水果。

艾拉的夜生活也非常丰富，有舒适的咖啡馆、酒吧和现场音乐场所，旅客可以在一天的冒险后放松身心。

艾拉将自然美景、文化和悠闲氛围完美结合，是自然爱好者和探险者必访的目的地。`
  };

  return (
    <div className="travel-form-container2">
      {/* Row 1 - Description */}
      <div className="row row-one2">
        <div className="col image-col2">
          <img src="./images/coverpage6.webp"  className="travel-image2" />
          <img src="./images/E1.webp" className="travel-image2" />
        </div>

        <div className="col content-col2">
          <h2>Ella</h2>

          {/* Language Toggle Button */}
          <div style={{ textAlign: 'right', marginBottom: '10px' }}>
            <button
              onClick={() => setLang(lang === 'en' ? 'zh' : 'en')}
              style={{
                padding: '8px 16px',
                borderRadius: '6px',
                border: 'none',
                backgroundColor: '#967969',
                color: 'white',
                cursor: 'pointer'
              }}
            >
              {lang === 'en' ? '切换到中文' : 'Switch to English'}
            </button>
          </div>

          {/* Paragraph */}
          <p style={{ whiteSpace: 'pre-line' }}>{content[lang]}</p>
        </div>
      </div>

      {/* Row 2 - Auto Carousel */}
      <div className="carousel-container2">
        <div className="carousel-heading-column">
          <h2 className="carousel-heading">Explore Ella</h2>
          <p className="carousel-subheading">Nature, adventure, and vibrant night life</p>
        </div>

        <div className="carousel2" ref={carouselRef}>
          {images.map((imgSrc, index) => (
            <img key={index} src={imgSrc} className="carousel-image2" />
          ))}
        </div>
      </div>

      {/* Footer */}
      <Footer />
    </div>
  );
};

export default TravelForm;
